import { ComponentProps } from 'react';
import { withFocusableSelect } from '../components/with-focusable-select';
import { ControlledSingleSelectFieldEditorPopover } from './controlled-single-select-field-editor-popover';

export const SingleSelectFieldEditorPopover = withFocusableSelect<
  number | null,
  ComponentProps<typeof ControlledSingleSelectFieldEditorPopover>
>(ControlledSingleSelectFieldEditorPopover);
